var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.402 144.696C9.128 178.352 0 216.109 0 256C0 295.891 9.128 333.648 25.402 367.304L256 389.565L486.598 367.304C502.872 333.648 512 295.891 512 256C512 216.109 502.872 178.352 486.598 144.696L256 122.435L25.402 144.696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4111 367.304C66.8171 452.935 154.506 512 256 512C357.493 512 445.183 452.935 486.589 367.304H25.4111Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4111 144.696H486.589C445.183 59.065 357.493 0 256 0C154.506 0 66.8171 59.065 25.4111 144.696Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.586 209.186L336.59 238.131L370.607 227.101L349.569 256.021L370.571 284.965L336.567 273.893L315.529 302.813L315.551 267.052L281.545 255.98L315.563 244.95L315.586 209.186Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.261 328.348C218.305 328.348 185.913 295.956 185.913 256C185.913 216.044 218.305 183.652 258.261 183.652C270.719 183.652 282.442 186.802 292.676 192.348C276.62 176.647 254.664 166.956 230.435 166.956C181.257 166.956 141.392 206.822 141.392 255.999C141.392 305.176 181.258 345.042 230.435 345.042C254.665 345.042 276.621 335.351 292.676 319.65C282.441 325.198 270.72 328.348 258.261 328.348Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibya);
export default __webpack_public_path__ + "static/media/libya.9160a5d4f8072ac8e06e321aa1f6b8b0.svg";
export { ForwardRef as ReactComponent };